export default {
    path: "/api",
    component: () => import("~/pages/api/index.vue"),
}